<section class="w-full lg:py-25 py-10 bg-zinc-50">
  <div class="flex flex-col items-center w-full px-4 lg:px-0 container gap-6 lg:gap-10">
    <div class="flex flex-col gap-4 items-center">
      <div class="flex flex-col gap-3 text-center">
        <p class="font-extrabold text-sm lg:text-lg text-gradient-primary bg-clip-text text-transparent">PHILOSOPHY</p>
        <h1 class="text-2xl lg:text-4xl lg:leading-14 text-zinc-800">
          좋은 공간의 <span class="font-extrabold">브랜드 철학</span>
        </h1>
      </div>
    </div>

    <div class="flex flex-col lg:flex-row w-full gap-6 lg:gap-10 max-w-7xl">
      <div
        class="lg:hidden relative w-full py-10 px-5 lg:py-16 lg:px-10 rounded-xl bg-cover bg-center bg-no-repeat flex flex-col justify-between gap-6"
        style="background-image: url('/home/philosophy.svg')">
        <app-icon
          name="dashicons:format-quote"
          class="size-6! lg:size-10! text-zinc-300 absolute top-5 right-5 lg:top-10 lg:right-10 rotate-180" />
        <h2 class="text-xl lg:text-4xl font-black text-[#E0002A]">
          <span>IN</span><span class="text-zinc-800">TEGRATED</span><br />
          <span>SERV</span><span class="text-zinc-800">ITCES OR</span><br />
          <span>CO</span><span class="text-zinc-800">MMUNICATION &</span><br />
          <span>MARK</span><span class="text-zinc-800">ETING</span>
        </h2>

        <div class="flex flex-col gap-2">
          <span class="w-1 h-1 rounded-full bg-zinc-700"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-500"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-300"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-200"></span>
        </div>

        <p class="text-zinc-500 text-base lg:text-lg font-medium leading-relaxed">
          통합적인 서비스로 소통과 마케팅을 실현하며,<br />
          고객의 입장에서 생각하고가치를 창조합니다.<br />
          화합과 소통을 바탕으로 시장의 흐름을 읽고<br />
          미래를 선도해 나갑니다.
        </p>
      </div>

      <div class="flex flex-1 flex-col items-center w-full gap-4 lg:gap-6">
        <div
          class="bg-zinc-100 rounded-2xl p-5 lg:p-11 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
          <div class="flex gap-2 items-center text-left">
            <h3 class="text-base lg:text-2xl font-black">
              <span class="text-[#E0002A]">IN</span><span class="text-zinc-800">TEGRATED</span>
            </h3>
            <div class="w-12 h-px bg-zinc-300"></div>
          </div>
          <p class="text-zinc-800 text-base lg:text-xl font-medium text-right">고객의 입장이 돼라</p>
        </div>

        <div
          class="bg-zinc-100 rounded-2xl p-5 lg:p-11 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
          <div class="flex gap-2 items-center text-left">
            <h3 class="text-base lg:text-2xl font-black">
              <span class="text-[#E0002A]">SERV</span><span class="text-zinc-800">ITCES</span>
            </h3>
            <div class="w-12 h-px bg-zinc-300"></div>
          </div>
          <p class="text-zinc-800 text-base lg:text-xl font-medium text-right">가치를 창조하라</p>
        </div>

        <div
          class="bg-zinc-100 rounded-2xl p-5 lg:p-11 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
          <div class="flex gap-2 items-center text-left">
            <h3 class="text-base lg:text-2xl font-black">
              <span class="text-[#E0002A]">CO</span><span class="text-zinc-800">MMUNICATION</span>
            </h3>
            <div class="w-12 h-px bg-zinc-300"></div>
          </div>
          <p class="text-zinc-800 text-base lg:text-xl font-medium text-right">화합과 소통을 추구하라</p>
        </div>

        <div
          class="bg-zinc-100 rounded-2xl p-5 lg:p-11 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
          <div class="flex gap-2 items-center text-left">
            <h3 class="text-base lg:text-2xl font-black">
              <span class="text-[#E0002A]">MARK</span><span class="text-zinc-800">ETING</span>
            </h3>
            <div class="w-12 h-px bg-zinc-300"></div>
          </div>
          <p class="text-zinc-800 text-base lg:text-xl font-medium text-right">시장의 흐름을 주시하라</p>
        </div>
      </div>

      <div
        class="hidden lg:flex relative flex-1 w-full pt-40 pb-15 px-10 rounded-xl bg-cover bg-center bg-no-repeat flex-col justify-between gap-6"
        style="background-image: url('/home/philosophy.svg')">
        <app-icon name="dashicons:format-quote" class="size-8! text-zinc-300 absolute top-40 right-16 rotate-180" />

        <h2 class="text-xl lg:text-4xl font-black text-[#E0002A]">
          <span>IN</span><span class="text-zinc-800">TEGRATED</span><span> SERV</span
          ><span class="text-zinc-800">ITCES OR</span><br />
          <span>CO</span><span class="text-zinc-800">MMUNICATION &</span><br />
          <span>MARK</span><span class="text-zinc-800">ETING</span>
        </h2>

        <div class="flex flex-col gap-2">
          <span class="w-1 h-1 rounded-full bg-zinc-700"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-500"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-300"></span>
          <span class="w-1 h-1 rounded-full bg-zinc-200"></span>
        </div>

        <p class="text-zinc-500 text-xl font-medium leading-relaxed">
          통합적인 서비스로 소통과 마케팅을 실현하며, 고객의 입장에서 생각하고<br />가치를 창조합니다. 화합과 소통을
          바탕으로 시장의 흐름을 읽고<br />
          미래를 선도해 나갑니다.
        </p>
      </div>
    </div>
  </div>
</section>
